import React from 'react';
import PropTypes from 'prop-types';

const SectionHeading = ({ title }) => {
    return <div className="menu-header">{title}</div>;
};

SectionHeading.propTypes = {
    title: PropTypes.string.isRequired
};

export default SectionHeading;
